<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="accordion margin-top-10px margin-bottom-10px" [id]="'accordionExample'+TitleText" *ngIf="mode!='view'">

  <div class="card margin-bottom-5px">
    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" [id]="'heading'+TitleText">
      <div class="row">
        <div class="col-md-3">
          <h5 class="mb-0 height-24px">
            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" attr.data-target="#collapse{{TitleText}}" aria-expanded="true" [attr.aria-controls]="'collapse'+TitleText" *ngIf="ChangedInseminationDate">
              {{TitleText}} ({{ChangedInseminationDate | date:'dd-MMM-yyyy' }})
            </button>
          </h5>
        </div>
        <div class="col-md-1">
          <!--<button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>-->
        </div>
        <div class="col-md-6 padding-left-0px text-align-right padding-right-6px">
          <button type="button" (click)="Addday()"
                  class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                  name="upload " title="Click Here To Add New Row" *ngIf="ActivityStatus !=='Completed'">
            <i class="fas fa-plus font-size-11"></i>
          </button>
        </div>

      </div>


    </div>

    <div [id]="'collapse'+TitleText" class="collapse show" [attr.aria-labelledby]="'heading'+TitleText" [attr.data-parent]="'#accordionExample'+TitleText">
      <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

        <div class="card margin-bottom-0px margin-top-10">

          <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px margin-left-0px">

            <div class="row">
              <div class="col-md-10 padding-right-0px">
                <div class="card margin-bottom-0px">

                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px margin-left-0px">
                    <div class="table-component margin-bottom-0px">
                      <div class="table-responsive">


                        <table class="table table-striped margin-left-zero">
                          <thead class="">
                            <tr>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='1'">Count</th>
                              <!--<th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Blastomere Count</th>-->
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='2' || DOC=='3' || DOC=='4' || DOC=='5' || DOC=='6'">Embryo Count</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='2' || DOC=='3'">Cell Count</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='4'">Cell Stage</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Stage</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px width-76px" *ngIf="DOC=='1'">OutCome</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='1'">Remarks</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC!== '1'">Grade</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Frozen</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Discarded</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Transfer</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="Doc==1 || DOC==2 || DOC==3 || DOC==4">Fragmentation</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Remarks</th>

                              <th class="td-well-width-79px padding-top-4px padding-bottom-4px font-size-12px"></th>
                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController">
                              <td class="padding-top-0px padding-bottom-0px text-align-center">
                                {{l.EmbryoCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC=='2'">
                                {{l.CellCount}}
                              </td>

                              <td class="padding-top-0px padding-bottom-0px" *ngIf="DOC=='4' || DOC=='3' || DOC=='5'||DOC=='6'">
                                {{l.CellStage}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px ">
                                <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="DOC!=='4'">{{l.Grade2}} </label>

                                <!--Day{{DOC}}Grade{{1}}-->
                                <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->

                              </td>
                              <td class="padding-top-0px padding-bottom-0px " *ngIf="DOC=='1'">
                                {{l.Remarks}}

                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.FrozenCount}}<button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-3px font-size-13px padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px min-width-24px height-20px" *ngIf="l.FrozenCount>0 && ActivityStatus !=='Completed'" (click)="Frozen(l)"><i class="fa fa-ellipsis-h nav-link-hand"></i></button>
                                <!--<label class="margin-bottom-0px margin-left-3px" *ngIf="l.FrozenCount>0" (click)="Frozen(l)"> [<i class="fa fa-ellipsis-h nav-link-hand"></i>]</label>-->
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.DiscardedCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.TransferCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="Doc==1 || DOC==2 || DOC==3 || DOC==4">
                                {{l.Fragmentation}}

                              </td>
                              <td class="padding-top-0px padding-bottom-0px " *ngIf="DOC!=='1'">
                                {{l.Remarks}}

                              </td>

                              <td class="padding-all-0px">
                                <div class="test-icons">
                                  <a (click)="Editday(l)" class="font-size-16px color-Assign" title="Edit" *ngIf="ActivityStatus !=='Completed'"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                  <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove" *ngIf="ActivityStatus !=='Completed'"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
<div class="accordion margin-top-10px margin-bottom-10px" [id]="'accordionExample'+TitleText" *ngIf="mode=='view'">

  <div class="card margin-bottom-5px">
    <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" [id]="'heading'+TitleText">
      <div class="row">
        <div class="col-md-3">
          <h5 class="mb-0 height-24px">
            <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" attr.data-target="#collapse{{TitleText}}" aria-expanded="true" [attr.aria-controls]="'collapse'+TitleText">
              {{TitleText}}
            </button>
          </h5>
        </div>
        <div class="col-md-1">
          <!--<button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>-->
        </div>
        <!--<div class="col-md-4 padding-left-0px text-align-right">
          <button type="button" (click)="Addday()"
                  class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
                  name="upload " title="Click Here To Add New Row">
            <i class="fas fa-plus font-size-11"></i>
          </button>
        </div>-->

      </div>


    </div>

    <div [id]="'collapse'+TitleText" class="collapse show" [attr.aria-labelledby]="'heading'+TitleText" [attr.data-parent]="'#accordionExample'+TitleText">
      <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

        <div class="card margin-bottom-0px margin-top-10">

          <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">

            <div class="row">
              <div class="col-md-8">
                <div class="card margin-bottom-0px">

                  <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                    <div class="table-component margin-bottom-0px">
                      <div class="table-responsive">


                        <table class="table table-striped margin-left-zero">
                          <thead class="">
                            <tr>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='1'">Count</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Blastomere Count</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='2' || DOC=='3' || DOC=='4'">Embryo Count</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='2' || DOC=='3'">Cell Count</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='4'">Cell Stage</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Stage</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC=='1'">OutCome</th>
                              <th class="padding-top-4px padding-bottom-4px font-size-12px" *ngIf="DOC!== '1'">Grade</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Frozen</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Discarded</th>
                              <th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC!=='1'">Transfer</th>
                              <!--<th class="td-well-width-79px padding-top-4px padding-bottom-4px font-size-12px"></th>-->
                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of CurrentIvfEmbryoGradingByCycleController">
                              <td class="padding-top-0px padding-bottom-0px text-align-center">
                                {{l.EmbryoCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC=='2'">
                                {{l.CellCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC=='4' || DOC=='3' || DOC=='5'||DOC=='6'">
                                {{l.CellStage}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px ">
                                <label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="DOC!=='4'">{{l.Grade2}} </label>

                                <!--Day{{DOC}}Grade{{1}}-->
                                <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->

                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.FrozenCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.DiscardedCount}}
                              </td>
                              <td class="padding-top-0px padding-bottom-0px text-align-center" *ngIf="DOC!=='1'">
                                {{l.TransferCount}}
                              </td>
                              <!--<td class="padding-all-0px">
                                <div class="test-icons">
                                  <a (click)="Editday(l)" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                  <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                </div>
                              </td>-->
                            </tr>

                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>



